import { ReactNode } from "react";

import { CloseWhiteIcon } from "@/components/icons/CloseWhiteIcon";
import { ModalNova } from "@/components/ui-kit/ModalNova/ModalNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

export interface CourseModalShellProps {
  closeModal: () => void;
  children: ReactNode;
  /** Hides every close control and blocks backdrop dismissal */
  dismissible?: boolean;
  /** Shows the bottom Close button on desktop too (mobile only by default) */
  showCloseOnDesktop?: boolean;
}

const CourseModalShell = ({
  closeModal,
  children,
  dismissible = true,
  showCloseOnDesktop = false,
}: CourseModalShellProps) => (
  <ModalNova
    hideModal={closeModal}
    fullHeightMobile={true}
    className="!bg-nova-base-black md:!max-w-[416px] lg:!max-w-[1072px]"
    backdropClassName="!bg-nova-transparency-white-10 backdrop-blur-[5px]"
    headerClassName="!p-0 max-md:!hidden"
    bodyClassName="!h-full !py-10 !px-6 md:!p-10"
    hideCloseTrigger={!dismissible}
    disableBackdropClick={!dismissible}
  >
    <div className="flex flex-col justify-center h-full w-full md:h-[780px] lg:h-[560px] xl:h-[640px] gap-2">
      <div className="flex-1 flex items-center justify-center h-full">{children}</div>
      {dismissible && (
        <div className={cn("text-center", !showCloseOnDesktop && "md:hidden")}>
          <button
            type="button"
            className="mx-auto p-1 text-nova-base-white"
            aria-label="Close"
            onClick={closeModal}
          >
            <span className="flex items-center gap-1 border-b border-b-nova-base-white">
              <CloseWhiteIcon />
              <TextElementNova
                element="span"
                text="Close"
                className="CTA-20-Dia-Normal text-nova-base-white !leading-[100%]"
              />
            </span>
          </button>
        </div>
      )}
    </div>
  </ModalNova>
);

export default CourseModalShell;
